import { render, staticRenderFns } from "./MonoLinkedinIcon.vue?vue&type=template&id=31088396&scoped=true"
import script from "./MonoLinkedinIcon.vue?vue&type=script&lang=js"
export * from "./MonoLinkedinIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31088396",
  null
  
)

export default component.exports